<!--
 * @FileDescription: 员工管理和往来单位左边树的结构（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-04-13（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div class="tree">
      <template v-if="newIndex == 1">
          <div class="department-left-top" @click="onSelectAll">
              <template v-if="tab == 1">全部部门</template>
              <template v-if="tab == 2">全部类别</template>
          </div>
          <a-tree defaultExpandAll  @select="onSelect" class="tree-model">
              <a-tree-node  v-for="(item,index) in treeList" :key="item.id"   >
                  <img src="@/assets/image/wenjian@2x(1).png" class="tree-img"  slot="switcherIcon"/>
                  <span slot="title" class="tree-span">
                      <span >{{item.name}}</span>
                  </span>
              </a-tree-node>
          </a-tree>
          <div class="tree-btn"  @click.stop="onPage(1)" v-if="tab == 1" v-has="'system_department_edit'">编辑部门</div>
          <div class="tree-btn" @click.stop="onPage(1)" v-if="tab == 2" v-has="'system_unit_type_edit'">编辑类别</div>
      </template>
      <template v-if="newIndex == 2">
          <div class="department-left-top">
              <template v-if="tab == 1">全部部门</template>
              <template v-if="tab == 2">全部类别</template>
              <a-popover trigger="click" placement="bottomLeft" v-model="locationPop">
                  <template slot="content">
                      <div class="tree-add">
                          <a-input placeholder="请输入名称" ref="inputss" v-focus v-model="treeInput" class="tree-add-input"   @pressEnter="pressEnterTree()"></a-input>
                          <div class="tree-add-btn">
                              <a-button class="manage-btn1" @click.stop="onTreeAddSave(1)">取消</a-button>
                              <a-button class="btn-save-next manage-btn1"  @click.stop="onTreeAddSave(2)">确认</a-button>
                          </div>
                      </div>
                  </template>
                  <img src="@/assets/image/add_shop_manage@2x.png"  @click.stop="onAddDepart()"  />
              </a-popover>
          </div>
          <a-tree defaultExpandAll  class="tree-model" v-clickoutside:[classList]="closeIconBlock">
              <a-tree-node  v-for="(item,index) in treeObj" :key="index" >
                  <img src="@/assets/image/wenjian@2x(1).png" class="tree-img"  slot="switcherIcon"/>
                  <span slot="title" class="tree-span" @click.stop="onClickTree(item,index)">
                      <span v-show="!item.isActive">{{item.name}}</span>
                      <template v-if="item.isActive">
                           <a-input v-model="item.name" class="tree-input" ref="inputs"  allowClear   @pressEnter="pressEnter(item)"></a-input>
                           <a-tooltip placement="bottom">
                                <template slot="title">
                                  <span>删除</span>
                                </template>
                                <img src="@/assets/image/cha_shanchu.png" @click.stop="onDeleteManage(item)" style="margin-left: 10px;width: 14px;height: 14px;margin-bottom: 2px"/>
                           </a-tooltip>
                      </template>
                  </span>
              </a-tree-node>
          </a-tree>
          <div class="tree-btn"  @click.stop="onPage(2)" >编辑完成</div>
      </template>
      <deleteModal ref="deleteModal" @confirmDeletion="confirmDeletion"></deleteModal>
  </div>
</template>
<script>
import {contactsave,contactupdate,contactDelete,updateDepart,deleteDepart,AddDepart} from "@/utils/api";
import {mixins} from "@/mixins/mixins";
import deleteModal from '@/components/module/deleteModal'
export default {
    mixins:[mixins],
    props:{
        treeList:{
            type:Array
        },
        index:{
            type:Number
        },
        tab:{
            type:Number
        }
    },
    data(){
        return{
            newIndex:'',
            treeObj:[],
            classList:[],
            locationPop:false,
            treeInput:'',
        }
    },
    watch: {
        index(){
            this.newIndex = this.index
        },
        treeList(){
          this.treeObj = this.treeList
        }
    },
    mounted () {
        this.newIndex = this.index
        this.treeObj = this.treeList
    },
    created () {

    },
    components: {
        deleteModal

    },
    methods: {
        /**
        * @description: 此为方法注释（方法描述）
        * @param {参数类型} 参数名称
        * @return void
        */
        onPage(index){
            if(index == 1){
                this.newIndex = 2
            }else{
                this.closeIconBlock()
                this.newIndex = 1
            }
        },
        /**
         * @description: 选择哪个部门（方法描述）
         */
        onSelect(keys,event){
            this.$emit('onSelectKey',keys[0])
        },
        onSelectAll(){
            this.$emit('onSelectAll')
            let li =document.getElementsByClassName('ant-tree-node-content-wrapper')
            for(let i=0;i<li.length;i++){
                li[i].classList.remove('ant-tree-node-selected')
            }
        },
        onClickTree(item,index){
            this.closeIconBlock()
            item.isActive = true
            this.$nextTick(()=>{
                this.$refs.inputs[0].focus()
                this.$refs.inputs[0].select()
                let inputLen = document.getElementsByClassName('tree-input')
                inputLen[0].onclick = function(event){
                    event.stopPropagation()
                }
            })
        },
        /**
         * @description: 失去焦点（方法描述）
         */
        closeIconBlock(){
            this.treeObj.forEach((item)=>{
                item.isActive = false
                if(this.isEmpty(item.name)){
                    item.name = item.name1
                }
            })
        },
        /**
         * @description: 回车（方法描述）
         */
        pressEnter(item){
            if(!this.isEmpty(item.name)){
                if(this.tab == 1){
                    updateDepart({
                        companyStoreId:this.$store.state.shopId,
                        companyId:this.$store.state.companyId,
                        id:item.id,
                        name:item.name,
                    },{}).then((res)=>{
                        if(res.success){
                            item.isCheck = false
                            this.$emit('saveDepart')
                        }else{
                            this.$message.warn(res.logMessage)
                        }
                    })
                }else{
                    contactupdate({
                        id:item.id,
                        companyStoreId:this.$store.state.shopId,
                        companyId:this.$store.state.companyId,
                        name:item.name
                    },{}).then((res)=>{
                        if(res.success){
                            item.isCheck = false
                            this.$emit('pageListTree')
                        }else{
                            this.$message.warn(res.logMessage)
                        }
                    })
                }
            }else{
                this.$message.warn('请输入内容')
                return;
            }

        },
        onAddDepart(){
            this.locationPop = true
        },
        /**
         * @description: 添加类型（方法描述）
         */
        onTreeAddSave(index){
            if(index == 1){
                this.locationPop = false
            }else{
               this.pressEnterTree()
            }
        },
        /**
         * @description: 添加类型（方法描述）
         */
        pressEnterTree(){
            if(this.tab == 1){
                AddDepart({
                    companyStoreId:this.$store.state.shopId,
                    companyId:this.$store.state.companyId,
                    name:this.treeInput
                },{}).then((res)=>{
                    if(res.success){
                        this.treeInput = ''
                        this.locationPop = false
                        this.$emit('saveDepart')
                    }else{
                        this.$message.warn(res.logMessage)
                    }
                })
            }else{
                contactsave({
                    companyStoreId:this.$store.state.shopId,
                    companyId:this.$store.state.companyId,
                    name:this.treeInput
                },{}).then((res)=>{
                    if(res.success){
                        this.treeInput = ''
                        this.locationPop = false
                        this.$emit('pageListTree')
                    }else{
                        this.$message.warn(res.logMessage)
                    }
                })
            }
        },
        confirmDeletion(item){
            let data = {
                id:item.id,
                companyStoreId:this.$store.state.shopId,
            }
            data =   this.$qs.stringify(data)
            if(this.tab == 1){
                deleteDepart(data,{}).then((res)=>{
                    if(res.success){
                        this.$emit('saveDepart')
                    }else{
                        this.$message.warn(res.logMessage)
                    }
                })
            }else{
                contactDelete(data,{}).then((res)=>{
                    if(res.success){
                        this.$emit('pageListTree')
                    }
                })
            }
        },
        onDeleteManage(item){
            item.content = '您确认要删除类别吗'
            this.$refs.deleteModal.show(item)
        },
    },

}
</script>
<style lang="scss">
    .tree{
        .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected{
            background-color: #F2F7FF !important;
        }
    }

</style>
<style scoped lang="scss">
.tree-img{
    width: 14px;
}
.tree{
    width: 100%;
    height: 100%;
    position: relative;
}
    .department-left-top{
        cursor: pointer;
        img{
            width: 16px;
            height: 16px;
            margin-left: 10px;
        }
    }
    .tree-model{
        max-height: calc(100vh - 490px);
        padding-bottom: 10px;
        overflow: auto;
        overflow-x: hidden;
    }
    .tree-btn{
        position: absolute;
        left: 0;
        bottom: 10px;
        width:90px;
        height:32px;
        background:rgba(250,250,250,1);
        border:1px solid rgba(230,230,230,1);
        border-radius:2px;
        color: var(--co);
        text-align: center;
        line-height: 32px;
        cursor: pointer;
    }
.tree-add{
    border-radius: 6px;
    height: 115px;
    .tree-add-input{
        width: 240px;
        margin: 10px 0 20px;
    }
    .tree-add-btn{
        display: flex;
        align-items: center;
        justify-content: center;
        .manage-btn1{
            width: 80px;
            height: 36px;
        }
        .btn-save-next{
            margin-left: 15px;
        }
    }
}

</style>
